import React from "react";
import { CardContent, Stack, Typography } from "@mui/material";
import P5Sketch from "../../../sketches/P5Sketch";
import "./CanvasCard.css";

const CanvasCard = ({ isGifSaved, setIsGifSaved, options, title }) => {
  return (
    <CardContent className="canvasContainer" sx={{padding:"0px", paddingLeft: "16px"}}>
      <Stack spacing={2} alignItems="center">
        <Typography variant="h6" className="canvasTitle">
          {title}
        </Typography>

        <P5Sketch
          key={JSON.stringify(options)}
          emotions={options.emotions}
          options={options}
          isGifSaved={isGifSaved}
          setIsGifSaved={setIsGifSaved}
          sketchName={title}
        />

        <Typography variant="body2" className="subtitle" color="text.secondary">
          {options.description}
        </Typography>
      </Stack>
    </CardContent>
  );
};

export default CanvasCard;
